<template>
  <div class="bubble-wrapper">
    <div ref="bubble" class="bubble" :class="getClasses()">{{btnText}}</div>
    <div ref="bubblePulse" class="bubble-pulse"></div>
  </div>
</template>

<script>
import { TimelineLite, Back, Elastic, Expo } from "gsap";
export default {
  props: {
    tooltip: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Array,
      required: false,
    },
    btnText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeline: null,
    };
  },
  mounted() {
    // restart the animation once its over
    this.timeline = new TimelineLite({
      onComplete: () => this.timeline.restart(),
    });
    const { bubble, bubblePulse } = this.$refs;
    const timeline = new TimelineLite();

    timeline.to(bubble, 0.4, {
      scale: 0.8,
      rotation: 16,
      ease: Back.easeOut.config(1.7),
    });
    timeline.to(
      bubblePulse,
      0.5,
      {
        scale: 0.9,
        opacity: 1,
      },
      "-=0.6"
    );

    this.timeline.to(bubble, 1.2, {
      scale: 1,
      rotation: "-=16",
      ease: Elastic.easeOut.config(2.5, 0.5),
    });
    this.timeline.to(
      bubblePulse,
      1.1,
      {
        scale: 3,
        opacity: 0,
        ease: Expo.easeOut,
      },
      "-=1.2"
    );
  },
  methods: {
    getClasses() {
      var valueHolder;
      valueHolder = "anim-btn ";
      if (this.disabled) valueHolder += "m-disabled ";
      if (this.type.includes("light")) valueHolder += "m-light ";
      if (this.type.includes("dark")) valueHolder += "m-dark ";
      if (this.icon) valueHolder += "m-icon";

      return valueHolder.trim();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/variables.scss";
.anim-btn.m-dark {
  background: $play-dark;
  color: white;
}

.anim-btn.m-light {
  background: $old-makeup-pink;
  color: white;
}


.bubble-wrapper {
  cursor: pointer;
  position: relative;
}

.bubble {
  font-weight: bold;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 100px;
  width: 100px;
}
.bubble-pulse {
  position: absolute;
  z-index: 1;
  height: 120px;
  width: 120px;
  top: 50%;
  left: 50%;
  margin-top: -60px;
  margin-left: -60px;
  background: #272727;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0);
}
.bubble-image {
  height: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/interface/buttons/AnimButton.vue